import { render, staticRenderFns } from "./RiceRatio.vue?vue&type=template&id=8a4ea65c&scoped=true"
import script from "./RiceRatio.vue?vue&type=script&lang=js"
export * from "./RiceRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4ea65c",
  null
  
)

export default component.exports